// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Spinner, Button } from 'react-bootstrap';
import { FaBox, FaDollarSign, FaShoppingCart } from 'react-icons/fa';

import loader from '../Assets/App_icon/loader.gif';

const store = localStorage.getItem('store');
const host_url = localStorage.getItem('host_url');

// Sample API call simulation function
const fetchDashboardData = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        totalProducts: 120,
        totalOrders: 350,
        totalSales: 5600.0,
      });
    }, 2000); // Simulated delay of 2 seconds
  });

      {/*
          // Simulate API data (replace with actual API calls)
          return {
            totalProducts: 120,
            totalOrders: 350,
            totalSales: 5600.0,
          };  
      */}
};

const Dashboard = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('../Homepage');
  };

  useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          handleBack();
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, []);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [navigate]);

 const [data, setData] = useState({
    totalProducts: 0,
    totalOrders: 0,
    totalSales: 0,
  });

 const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      const dashboardData = await fetchDashboardData();
      setData(dashboardData);
      setLoading(false);
    };
    getData();
  }, []);

  const handleCashback = async () => {
      try {
        const response = await fetch(`${host_url}/ref_cashback`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'list', 
            store: store,  
          }),
        });
        const data = await response.json();
        console.log(data);
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

  return (
    <div className="dashboard">
      <h2 className="my-4">Dashboard</h2>
      {loading ? (
        <div className="text-center">
          <img src={loader} alt="Back" />
          <p>Loading data...</p>
        </div>
      ) : (

        <Row>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FaBox size={40} color="#007bff" />
                <Card.Title className="mt-3">Products</Card.Title>
                <Card.Text>{data.totalProducts}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FaShoppingCart size={40} color="#28a745" />
                <Card.Title className="mt-3">Orders</Card.Title>
                <Card.Text>{data.totalOrders}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="text-center">
              <Card.Body>
                <FaDollarSign size={40} color="#fd7e14" />
                <Card.Title className="mt-3">Sales</Card.Title>
                <Card.Text>${data.totalSales.toFixed(2)}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

      )}  
    </div>
  );
};

export default Dashboard;
